import { $api } from "@/shared/api";

// Запрос разбора. Его `queryKey` используют `useAnalysis`, обработчики событий
// (`setQueryData`, `invalidateQueries`) и запуск разбора.
export const analysisQueryOptions = (analysisId: number) =>
  $api.queryOptions("get", "/api/analyses/{analysis_id}", {
    params: { path: { analysis_id: analysisId } },
  });
